<script type="ts">
import type {RenderOptions} from '../browser';
import { ScoreMethod, randomizeOptions, pickRandom, TIFImages, ExtraImages, JPGImages, checkOptionsNameMatch } from '../browser';
import ImageRender from "../components/ImageRender.svelte";

const combined = TIFImages.concat(ExtraImages, JPGImages);

let currentOptions: RenderOptions = {
    score: ScoreMethod.SCORE_NCC,
    cropping: true,
    multiscale: true,
    colorize: true
};

let imname = 'emir';

const onOff = (a) => {
    return a ? 'on' : 'off';
}

const checkChanges = () => {
    if (JPGImages.includes(imname) && currentOptions.multiscale) {
        currentOptions.multiscale = false;
    } else if (!JPGImages.includes(imname) && !currentOptions.multiscale) {
        currentOptions.multiscale = true;
    }
}

const randomize = () => {
    do {
        imname = pickRandom(combined);
        currentOptions = randomizeOptions();
    } while (!checkOptionsNameMatch(currentOptions, imname));
}
</script>

<section>
    <h2>Gallery</h2>
    <p>Use the interactive gallery tool below to explore the different renders at different stages.</p>
    <span>Pick an image:</span>
    <select bind:value="{imname}" on:change="{checkChanges}">
        <optgroup label="High resolution scans (.tif)">
            {#each TIFImages as name}
                <option value="{name}">{name}</option>
            {/each}
        </optgroup>
        <optgroup label="Low resolution scans (.jpg)">
            {#each JPGImages as name}
                <option value="{name}">{name}</option>
            {/each}
        </optgroup>
        <optgroup label="Extra high-res scans (.tif)">
            {#each ExtraImages as name}
                <option value="{name}">{name}</option>
            {/each}
        </optgroup>
    </select>
    <button on:click="{randomize}">Randomize!</button>
    <div class="action-container">
        <div class="action-item" class:enabled="{currentOptions.cropping}" on:click="{() => currentOptions.cropping = !currentOptions.cropping}">
            <div class="action-item-icon">📸</div>
            <div class="action-item-subtitle">Crop {onOff(currentOptions.cropping)}</div>
        </div>
        <div class="action-item" class:enabled="{currentOptions.colorize}" on:click="{() => currentOptions.colorize = !currentOptions.colorize}">
            <div class="action-item-icon">🌈</div>
            <div class="action-item-subtitle">Color {onOff(currentOptions.colorize)}</div>
        </div>
        <div class="action-item" class:enabled="{currentOptions.score == ScoreMethod.SCORE_NCC}" on:click="{() => currentOptions.score = (currentOptions.score == ScoreMethod.SCORE_NCC ? ScoreMethod.SCORE_SSD : ScoreMethod.SCORE_NCC)}">
            <div class="action-item-icon">🧲</div>
            <div class="action-item-subtitle">{currentOptions.score.toUpperCase()} matching</div>
        </div>
    </div>
    <ImageRender options={currentOptions} image="{imname}"/>
</section>

<style>
.action-container {
    display: flex;
    margin: 20px 0;
}

.action-item {
    border-top: 6px solid #CCC;
    border-radius: 8px;
    box-shadow: 0 4px 8px 4px rgba(100, 100, 100, .1);
    cursor: pointer;
    text-align: center;
    min-width: 100px;
    padding: 20px 16px;
    margin: 0 5px;
    transition: 150ms ease;
}

.action-item:hover {
    background: #FCFCFC;
    border-top-color: #AAA;
}

.action-item.enabled {
    border-top-color: #4fccd4;
}

.action-item-icon {
    font-size: 2em;
    margin-bottom: 10px;
}

.action-item-subtitle {
    font-size: 0.9em;
}
</style>